export class Organizer {
	id:string;
	name:string;
	shortName:string;
	merchantAccountId:string;
	contactEmail:string;
	convenienceFeeRate:string;
	convenienceFeeWording:string;
	convenienceFeeName:string;
	collectConvenienceFee:string;
	phone:string;
	url:string;
	address:string;
	city:string;
	state:string;
	postal_code:string;
	country:string;

	constructor(values: Object = {}) {
		Object.assign(this, values);
	}

}